import {Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[ExgAdaptiveHeight]'
})
export class ExgAdaptiveHeightDirective {

  @Input() set adaptiveHeightActive(value: boolean) {
    this._adaptiveHeightActive = value;
    setTimeout((e: any) => {
      this.setMaxHeight();
    }, 50);
  }
  get adaptiveHeightActive(): boolean {
    return this._adaptiveHeightActive;
  }
  @Input() set adaptiveHeightOffset(value: number) {
    this._adaptiveHeightOffset = value;
  }
  get adaptiveHeightOffset(): number {
    return this._adaptiveHeightOffset;
  }

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  _adaptiveHeightActive = false;
  _adaptiveHeightOffset = 0;

  @HostListener('window:resize', [])
  onWindowResize(): void {
    if (this.adaptiveHeightActive) {
      this.setMaxHeight();
    }
  }

  private setMaxHeight(): void {
    if (this.adaptiveHeightActive) {
      const viewportHeight = window.innerHeight;
      const elementRect = this.el.nativeElement.getBoundingClientRect();
      const yPosition = elementRect.top;
      const maxHeight = viewportHeight - yPosition - this.adaptiveHeightOffset;
      this.renderer.setStyle(this.el.nativeElement, 'max-height', `${maxHeight}px`);
    }
  }
}
